import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=30da5fea&scoped=true&"
import script from "./EditCourse.vue?vue&type=script&lang=js&"
export * from "./EditCourse.vue?vue&type=script&lang=js&"
import style0 from "./EditCourse.vue?vue&type=style&index=0&id=30da5fea&prod&scoped=true&lang=css&"
import style1 from "./EditCourse.vue?vue&type=style&index=1&id=30da5fea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da5fea",
  null
  
)

export default component.exports